import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Person } from '@crm/shared/persons/types';
import { EntityId } from '@shared/core/types';

@Injectable({
  providedIn: 'root',
})
export class PersonPageSharedService {
  private person$: Observable<Person>;
  private personId: EntityId = 0;

  getPerson(): Observable<Person> {
    return this.person$;
  }

  getPersonId(): EntityId {
    return this.personId;
  }

  setPerson(person$: Observable<Person>): void {
    this.person$ = person$;
  }

  setPersonId(personId: EntityId): void {
    this.personId = personId;
  }
}
